import React from 'react';
import PropTypes from 'prop-types';

const bottom = (props) => {
	const { data } = props;
	const {
		createTitle,
		createButtonLabel,
		createUrl,
	} = data;
	return (
		<div className="G1-login__view u-center">
			<h2 className="G1-login__title">{createTitle}</h2>
			<a href={createUrl} className="btn btn--primary btn--inverted G1-login__button">
				{createButtonLabel}
			</a>
		</div>
	);
};

bottom.propTypes = {
	data: PropTypes.shape({}).isRequired,
};

export default bottom;
